import Vue from 'vue';
import Router from 'vue-router'

/**
 * 这里对Router的原型进行了二次封装
 * pushPage()用于进入新页面使用，forwardPage()用于返回上一界面使用
 * replacePage()用于替换当前界面使用
 * nextReload用于界面跳转时，在beforeRouteEnter中判断是否需要重新获取数据/执行初始化代码使用
 * */
Router.prototype.pushPage = function (param) {
  //this.currentRoute.meta.nextTransition = 'fade-in';
  this.currentRoute.meta.nextReload = true;
  this.push(param);
};
Router.prototype.forwardPage = function (nextReload) {
  //this.currentRoute.meta.nextTransition = 'fade-out';
  this.currentRoute.meta.nextReload = nextReload || false;
  this.back();
};
Router.prototype.replacePage = function (param) {
  //this.currentRoute.meta.nextTransition = 'fade-in';
  this.currentRoute.meta.nextReload = true;
  this.replace(param);
};
Vue.use(Router);

const Home = resolve => require(['../views/Home/home.vue'], resolve);
const About = resolve => require(['../views/Home/about.vue'], resolve);
const News = resolve => require(['../views/Home/news.vue'], resolve);
const youchaoIndex = resolve => require(['../views/youchao/youchaoIndex.vue'], resolve);
const storeDetail = resolve => require(['../views/youchao/store-detail.vue'], resolve);
const houseTypeDetail = resolve => require(['../views/youchao/house-type-detail.vue'], resolve);
const CommunityLiving = resolve => require(['../views/youchao/community-living.vue'], resolve);
const Community3i = resolve => require(['../views/youchao/community-3i.vue'], resolve);
const CommunityYo = resolve => require(['../views/youchao/community-yo.vue'], resolve);
const privacyPolicy = resolve => require(['../views/youchao/privacyPolicy.vue'], resolve);
const payResult = resolve => require(['../views/youchao/pay-result.vue'], resolve);
const routes = [{
    path: '/',
    redirect: {
      name: 'youchaoIndex'
    },
    component: youchaoIndex
  },
  {
    path: '/youchaoIndex',
    name: 'youchaoIndex',
    component: youchaoIndex
  },
  {
    path: '/storeDetail',
    name: 'storeDetail',
    component: storeDetail
  },
  {
    path: '/houseTypeDetail',
    name: 'houseTypeDetail',
    component: houseTypeDetail
  },
  {
    path: '/home',
    name: 'home',
    query: {
      newsInfo: {},
      aboutInfo: {}
    },
    component: Home,
  },
  {
    path: '/home/about',
    name: 'about',
    component: About,
  },
  {
    path: '/home/news',
    name: 'news',
    component: News,
  },
  {
    path: '/community-living',
    name: 'CommunityLiving',
    component: CommunityLiving,
  },
  {
    path: '/community-3i',
    name: 'Community3i',
    component: Community3i,
  },
  {
    path: '/community-yo',
    name: 'CommunityYo',
    component: CommunityYo,
  },
  {
    path: '/pay-result',
    name: 'payResult',
    component: payResult,
  },
  {
    path: '/home/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy,
    meta: {
      title: '隐私政策'
    }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js